import React, { useEffect, useMemo } from 'react'
import { Table, useMediaSize } from '@ally/metronome-ui'
import { isAutoAccountWithNoActiveVehicle } from './utils'
import { getColumns } from './TableColumns'
import { useCustomizeDashboard } from '../CustomizeDashboard/CustomizeDashboardContext'
import { DashboardView } from '../CustomizeDashboard/types'
import AccountGroup from '../Shared/AccountGroup'
import AccountCard from '../Shared/AccountCard'
import { useAccountTypes } from '../AccountTypeContext'

import MobileVehicleAccountList from '../Shared/MobileAccountsCard/MobileVehicleAccountList'
import { VehicleAccountWell } from './VehicleAccountWell'
import NoActiveAccounts from './NoActiveAccounts'
import StaleDataNotice from '../Shared/StaleDataNotice'

const VehiclesCard: React.FC = () => {
  const { allAutoAccounts, hasStaleAutoAccounts } = useAccountTypes()
  const isMdDown = useMediaSize('MdDown')
  const isLgDown = useMediaSize('LgDown')
  const isPrint = window.matchMedia('print').matches
  const [{ dashboardView }] = useCustomizeDashboard()

  const isDefaultView = dashboardView === DashboardView.DEFAULT || isLgDown

  const isAllAutoAccountsWithNoActiveVehicle = useMemo(
    () =>
      allAutoAccounts.every(account =>
        isAutoAccountWithNoActiveVehicle(account),
      ),
    [allAutoAccounts],
  )

  useEffect(() => {
    if (hasStaleAutoAccounts) {
      window.allytm.event(
        'customError',
        "We've hit a snag when trying to update your account information. A fix is in the works.",
      )
    }
  }, [hasStaleAutoAccounts])

  return (
    <>
      {isAllAutoAccountsWithNoActiveVehicle ? (
        <NoActiveAccounts />
      ) : (
        <AccountGroup name="vehicles">
          {hasStaleAutoAccounts && (
            <StaleDataNotice dataTestId="stale-vehicle-notice" />
          )}
          <AccountCard type="auto">
            {isMdDown && !isPrint ? (
              <MobileVehicleAccountList accounts={allAutoAccounts} />
            ) : (
              <>
                {allAutoAccounts.length && (
                  <Table
                    data={allAutoAccounts}
                    columns={getColumns({ isDefaultView })}
                    captionText="Information about your Ally Vehicle accounts"
                    fullWidth
                    suppressMdDownLayout
                    withFooter
                  />
                )}
              </>
            )}
            <VehicleAccountWell />
          </AccountCard>
        </AccountGroup>
      )}
    </>
  )
}

export default VehiclesCard
